export { default } from './CarrosEletricosConsultar';
